// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3ot12","header":"PatientBlock_header__8YqQb","label":"PatientBlock_label__35JQN","option":"PatientBlock_option__1vxaG"};